import React, { useState, useEffect } from 'react';
import VideoJS from 'video.js';
import './MyTimeDisplay.less';

const MyTimeDisplay = (props: any): React.ReactElement => {
  const { bridge, spliter = '/' } = props;
  const [currentTime, setCurrentTime] = useState('');
  const [duration, setDuration] = useState('');

  useEffect(() => {
    if (!bridge) return;

    const player = bridge.player();

    player.on('timeupdate', () => {
      updateTimeHandler(player);
    });

    return () => {
      player.off('timeupdate', updateTimeHandler);
    };
  }, [bridge]);

  const updateTimeHandler = (player: any): void => {
    let currentTime = player.currentTime();
    let duration = player.duration();
    currentTime = VideoJS.formatTime(currentTime, 600);
    duration = VideoJS.formatTime(duration, 600);
    setCurrentTime(currentTime);
    setDuration(duration);
  };

  return (
    <>
      <span className="current">{currentTime}</span>
      <span className="intelligence-time-display-spliter">{spliter}</span>
      <span className="duration">{duration}</span>
    </>
  );
};

export default MyTimeDisplay;
